import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'antd';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {서버 전송 버튼 - 수정, 등록 페이지(or 모달) 내부}
 */

interface IProps {
  children?: string | JSX.Element;
  disabled?: boolean;
  onClick?: (e: any) => void;
  htmlType?: 'button' | 'submit' | 'reset' | undefined;
  style?: React.CSSProperties;
  typename?: string | undefined; // 버튼 백그라운드 컬러 변경을 위한 prop
  backColor?: string; // 배경 컬러
  textColor?: string; // 텍스트 컬러
}
const SubmitButton: React.FC<IProps> = ({
  typename,
  children,
  onClick,
  htmlType,
  disabled,
  style,
  backColor,
  textColor,
  ...props
}) => {
  // console.log(typename);
  return (
    <ButtonStyled
      typename={typename}
      onClick={onClick}
      // htmlType={htmlType}
      disabled={disabled}
      style={style}
      backColor={backColor}
      textColor={textColor}
      {...props}
    >
      {children}
    </ButtonStyled>
  );
};

export default SubmitButton;

const ButtonStyled = styled(Button)`
  background-color: ${(props) =>
    props.backColor ? props.backColor : props.theme.colors.primary};
  /* background-color: ${(props) =>
    props.typename === 'del' ? 'gray' : props.theme.colors.primary}; */

  border: none;
  height: unset;
  border-radius: 0.3rem;

  span {
    margin: 0.2rem 1.3rem 0.2rem 1.3rem;
    font-weight: 600;
    /* color: ${(props) => props.theme.colors.blueText}; */
    color: ${(props) => (props.typename === 'del' ? 'gray' : '#fff')};
  }
  /* TODO! 호버 효과 더 멋지게 해보자 */
  &:hover {
    background-color: ${(props) => props.theme.colors.table_button};
    /* box-shadow: 0 0px 2px 2px ${theme.colors.blue_2} inset; */
  }

  &:focus,
  &:active {
    /* background-color: ${(props) => props.theme.colors.table_button}; */
    background-color: ${theme.colors.table_button};
  }

  ${(props) =>
    props.typename === 'goBack' &&
    css`
      background-color: #fff;
      border: 1px solid ${theme.colors.primary};
      span {
        color: ${theme.colors.primary};
      }
    `}
  ${(props) =>
    props.typename === 'otome' &&
    css`
      background-color: ${theme.colors.primary};
      border: 1px solid ${theme.colors.primary};
      span {
        color: #fff;
      }
      &:hover,
      &:active {
        transition: all 0.5s;
        background-color: ${theme.colors.otomePrimaryDark};
        border: 1px solid ${theme.colors.otomePrimaryDark};
      }
      &:focus {
        transition: all 0.5s;
        /* background-color: none;
        border: 1px solid ${theme.colors.primary}; */
        background-color: ${theme.colors.primary};
        border: 1px solid ${theme.colors.primary};
      }
    `}
  ${(props) =>
    props.typename === 'otomeBack' &&
    css`
      background-color: #fff;
      border: 1px solid ${theme.colors.primary};
      span {
        color: ${theme.colors.primary};
      }
      &:hover,
      &:active {
        transition: all 0.5s;
        background-color: ${theme.colors.otomePrimaryDark};
        border: 1px solid ${theme.colors.otomePrimaryDark};
      }
      &:focus {
        transition: all 0.5s;
        /* background-color: none;
        border: 1px solid ${theme.colors.primary}; */
        background-color: #fff;
        border: 1px solid ${theme.colors.primary};
      }
    `}
`;
